import { parseISO } from 'date-fns';
import React from "react";
import ReactLoading from 'react-loading';
import { AppRoutes } from "../../domain/navigation/AppRoutes";
import { EventNames } from "../../domain/events/Events";
import { ICalendarEvent } from "../../domain/calendars/ICalendarEvent";
import { dateFormat, isoDateString } from "../../helpers/dateHelpers";
import { AttentionDaysGridLayout } from "../attentionday/AttentionDaysGridLayout";
import { DateNavigator, DateNavigatorType } from "../basic/DateNavigator";
import { BaseComponent } from "../core/BaseComponent";
import { EditAbsencePopup } from "./EditAbsencePopup";
import { InMeetingPopup } from "./InMeetingPopup";
import { ICalendar } from "../../domain/calendars/ICalendar";
import "./AbsenceDay.css";

interface IEditCalendarEvent {
    calendar: ICalendar;
    event: ICalendarEvent;
}

interface AbsenceDayProps {
    date: Date;
    bhvMode: boolean;
}
interface AbsenceDayState {
    isLoading: boolean;
    isCurrentlyInMeeting: boolean
    lastSynctAt?: Date;
    editEvent?: IEditCalendarEvent;
    editing: boolean;
}
export class AbsenceDay extends BaseComponent<AbsenceDayProps, AbsenceDayState> {
    state: AbsenceDayState = {
        isLoading: false,
        isCurrentlyInMeeting: false,
        editing: false
    };
    constructor(props: AbsenceDayProps) {
        super(props);
        this.subscribe<IEditCalendarEvent>(EventNames.editAbsence, (data) => {
            this.setStateWhenMounted({ editEvent: data, editing: true });
        });
    }
    navigateToDate(date: Date | null) {
        if (!date) {
            date = new Date();
        }
        this.navigateTo(`${AppRoutes.day}/${isoDateString(date)}`);

    }
    updateLoading(isLoading: boolean, isCurrentlyInMeeting: boolean, lastSynctAt?: Date) {
        if (!lastSynctAt) {
            lastSynctAt = (this.state || {}).lastSynctAt;
        }

        this.setStateWhenMounted({ isLoading, isCurrentlyInMeeting, lastSynctAt });
    }
    render() {
        const date = this.props.date;
        return (<div>
            <div className="toolbar">
                <DateNavigator value={date} onChange={this.navigateToDate.bind(this)} type={DateNavigatorType.TypeDate} />
                <InMeetingPopup currentlyInMeeting={this.state && this.state.isCurrentlyInMeeting}></InMeetingPopup>
                {this.state && this.state.isLoading ? <ReactLoading type="bars" color="rgba(219, 0, 47, 1)" className="react-loading" height="43px" width="43px" /> : null}

                <span>
                    <span>{this.state && this.state.lastSynctAt && 'Gesynchroniseerd op: '}</span>
                    <span>{this.state && this.state.lastSynctAt && dateFormat(parseISO(this.state.lastSynctAt as any), "HH:mm:ss")}</span>
                </span>
            </div>
            <AttentionDaysGridLayout date={date} onLoading={this.updateLoading.bind(this)} showPresentAndAbsencesInGroups={this.props.bhvMode} />
            {this.getEditAbsencePopup()}
        </div>);
    }
    getEditAbsencePopup() {
        const toggleEdit = () => this.setStateWhenMounted({ editing: false });
        const { editing, editEvent } = this.state;
        if (editing && editEvent) {
            return <EditAbsencePopup key={editEvent?.calendar.id} calendar={editEvent?.calendar!} calendarEvent={editEvent?.event!} closeFn={toggleEdit} date={this.props.date}></EditAbsencePopup>
        }
        return <></>;
    }
}
